<template>
    <BaseNotification theme="error" hide-dismiss>
        <template #content>
            <div class="flex flex-col md:flex-row justify-between gap-2 md:gap-4 items-center">
                <i class="bi bi-exclamation-triangle text-2xl" aria-hidden="true"></i>
                <div class="body-small">{{ t("analytics.filters.insufficientData") }}</div>
                <BaseButton theme="tertiary" size="sm" @click="$emit('resetFilters')">{{ t("analytics.filters.clear") }}</BaseButton>
            </div>
        </template>
    </BaseNotification>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineEmits<{
    resetFilters: [];
}>();
</script>
